import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FiltersProvider } from 'components/common/filter';
import {
  CalendarEventFeedbackQuestions,
  CalendarEventFeedbackResponses,
  CalendarEventFeedbackSummary
} from '.';

import type { CalendarEventFeedbackQuestion } from 'shared-types';
import type {
  GetCalendarEventFeedbackAnalyticsRes,
  GetCalendarEventFeedbackFormRes
} from 'shared-types/responses';

const CalendarEventFeedback = () => {
  const {
    pageState: { calendarEvent }
  } = useReduxState();

  const getQuestionHref = (question: CalendarEventFeedbackQuestion) =>
    `/calendar/${calendarEvent.id}/feedback/questions/${question.id}`;

  const formUrl = `/admin/calendar-events/${calendarEvent.id}/feedback-form`;

  const { data, loading, updateData } =
    useApiData<GetCalendarEventFeedbackFormRes>({ url: formUrl });

  const { data: analyticsData, updateData: updateAnalytics } =
    useApiData<GetCalendarEventFeedbackAnalyticsRes>({
      url: `${formUrl}/analytics`
    });

  return (
    <div className="feedback">
      <div className="section">
        <CalendarEventFeedbackSummary />
      </div>

      <div className="section">
        <CalendarEventFeedbackQuestions
          analyticsByQuestionId={analyticsData?.analyticsByQuestionId}
          applyTemplateUrl={`${formUrl}/apply-template`}
          getQuestionHref={getQuestionHref}
          hasSubmissions={data?.hasSubmissions || false}
          loading={loading}
          questions={data?.form?.questions || []}
          questionsOrderUrl={`${formUrl}/questions-order`}
          questionsUrl={formUrl}
          updateQuestions={updateData}
        />
      </div>

      <div className="section">
        <FiltersProvider filters={{ groups: true, userAttributes: true }}>
          <CalendarEventFeedbackResponses
            updateAnalytics={updateAnalytics}
            updateQuestions={updateData}
          />
        </FiltersProvider>
      </div>

      <style jsx>{`
        .feedback {
          display: flex;
          flex-direction: column;
          gap: 50px;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventFeedback;
